import { Button, type ButtonProps } from "@heroui/react";
import { twMerge } from "tailwind-merge";


export default function CustomButton({ children, color, className, ...props }:ButtonProps) {
    const getColorClass = (color?: string) => {
        switch(color) {
            case 'primary':
                return 'bg-[var(--okay-button)] hover:bg-blue-600 disabled:bg-gray-400 disabled:text-gray-600';
            case 'secondary':
                return 'bg-gray-500 hover:bg-gray-600 disabled:bg-gray-400 disabled:text-gray-600';
            case 'success':
                return 'bg-green-500 hover:bg-green-600 disabled:bg-gray-400 disabled:text-gray-600';
            case 'danger':
                return 'bg-red-500 hover:bg-red-600 disabled:bg-gray-400 disabled:text-gray-600';
            case 'warning':
                return 'bg-yellow-500 hover:bg-yellow-600 disabled:bg-gray-400 disabled:text-gray-600';
            case 'info':
                return 'bg-cyan-500 hover:bg-cyan-600 disabled:bg-gray-400 disabled:text-gray-600';
            case 'dark':
                return 'bg-[var(--okay-button)] hover:bg-gray-900 disabled:bg-gray-400 disabled:text-gray-600';
            case 'light':
                return 'bg-gray-200 hover:bg-gray-300 text-gray-800 disabled:bg-gray-400 disabled:text-gray-600';
            default:
                return 'bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 disabled:text-gray-600';
        }
    };

    const baseClasses = twMerge(`border-dark-primary border-solid text-sm font-semibold ${getColorClass(color)}`, className);
    
    return (
        <Button className={baseClasses} {...props}>
            {children}
        </Button>
    );
}
